import { CREATEIPDPATIENT, DELETEIPDOUTBILL, DELETEIPDPATIENT, GETALLIPD, GETALLIPDOUTBILL, GETIPDOUTBILL, GETIPDPATIENT, GETIPDPATIENTBYID, GETIPDPATIENTLIKE, UPDATEIPDOUTBILL, UPDATEIPDPATIENT, UPDATEIPDPATIENTACTION } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEIPDPATIENT:
            return {
                ...state,
                   patientSaveStatus: action.payload.success,
            }
        case GETIPDPATIENT:
                return {
                        ...state,
                        ipdpatientList: action.payload.data,
                        }
        case GETIPDPATIENTLIKE:
                return {
                        ...state,
                        ipdpatientlikeList: action.payload.data,
                        }
        case GETALLIPD:
                return {
                        ...state,
                        allipdvisitsList: action.payload.data,
                        }
        case UPDATEIPDPATIENT:
                return {
                        ...state,
                        ipdpatientUpdateStatus: action.payload.success,
                        }
        case UPDATEIPDPATIENTACTION:
                return {
                        ...state,
                        ipdpatientactionUpdateStatus: action.payload.success,
                        }    
        case GETIPDPATIENTBYID:
                return {
                        ...state,
                        ipdpatientbyidList: action.payload.data,
                        }
        case DELETEIPDPATIENT:
                 return {
                     ...state,
                     ipdpatientDeleteStatus: action.payload.success,
                        } 
    
                        default:
                            return state
                             }
                         }